<template>
  <product-bundled-upsells
    v-if="bundleUpsells.length"
    :bundle-selection
    data-test-id="product-upsell"
    :subtitle="bundlePromo?.promoDetails || $t.bundleUpsellSubtitle"
    :title="splitBundleCalloutMessage(bundlePromo?.calloutMessage).pdp || $t.bundleUpsellTitle"
    :upsells="bundleUpsells"
    @open-quickshop="handleOpenQuickshop($event)"
    @rec-click="handleRecClick"
    @remove="removeBundleSelection($event)"
  />
</template>

<script lang="ts" setup>
import type { Product } from '#root/api/clients/product/data-contracts'
import type { InteractionOrigin, ProductClickAction, ProductContext } from '#types/gtm'

const { $gtm } = useNuxtApp()
const {
  bundlePromo,
  bundleSelection,
  bundleUpsells,
  openQuickshop,
  removeBundleSelection,
  upsertBundleSelection
} = usePdp()

const gtmConfig: ProductContext & { appSource?: InteractionOrigin } = {
  appSource: 'up-sell-complete-the-look',
  category: 'UpSellCompleteTheLook',
  list: 'UpSellCompleteTheLook'
}

const handleOpenQuickshop = async (upsell: Product) => {
  // re-opening an already-staged item pre-fills the dialog with its existing variant pick (AC3 edit)
  const existing = bundleSelection.value.find(({ product }) => product.id === upsell.id)
  const selection = await openQuickshop(upsell, {
    context: 'bundle-selection',
    gtmConfig,
    initialAttributes: existing?.attributes,
    isUpsell: true,
    variant: 'detailed'
  })
  if (selection) upsertBundleSelection(selection)
}

const handleRecClick = (id: string, action?: ProductClickAction) => {
  const index = bundleUpsells.value.findIndex((upsell) => upsell.id === id)
  if (index === -1) return
  const upsell = bundleUpsells.value[index]
  const position = index + 1
  $gtm.push('upsell.onUpsellClick', upsell, position, { action })
  setInteractionOrigin('up-sell-complete-the-look', true)
}
</script>
